import type * as z from "zod";
import { searchInputOf, searchResultOf } from "../search";

// What the catalog finds (ADR-117). Each type needs the permission of its list, and the same one opens it in the app.

export const catalogSearchTypes = ["linesheet", "product", "sku"] as const;
export type CatalogSearchType = (typeof catalogSearchTypes)[number];

export const catalogSearchPermissions = {
  linesheet: "linesheet.read",
  product: "product.read",
  sku: "product.read",
} as const satisfies Record<CatalogSearchType, string>;

export const searchCatalogInput = searchInputOf(catalogSearchTypes);
export type SearchCatalogInput = z.input<typeof searchCatalogInput>;

export const catalogSearchDto = searchResultOf(catalogSearchTypes).meta({ id: "CatalogSearch" });
export type CatalogSearch = z.output<typeof catalogSearchDto>;
